import { render, staticRenderFns } from "./my-spa-example-page.vue?vue&type=template&id=1d460b52&scoped=true"
import script from "./my-spa-example-page.vue?vue&type=script&lang=js"
export * from "./my-spa-example-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d460b52",
  null
  
)

export default component.exports